import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { checkoutModalHandler } from 'utils/sendMessage'
import { pushWithLanguageRoutes } from 'utils/translation'

import type { PaywallStore, PaywallType } from '../types'
import { typeToMixpanelProps } from '../constants/type-to-mixpanel-props'

const initialState = {
  isOpen: false,
  type: null,
  descriptionVariable: null,
}

export const usePaywallStore = create<PaywallStore>()(
  devtools(
    (set, get) => {
      const closePaywall = () => set(initialState)

      const openCheckout = () => {
        const { type } = get()
        if (!type) return
        closePaywall()
        checkoutModalHandler({ mixpanelProps: typeToMixpanelProps[type] })
      }

      return {
        ...initialState,
        openPaywall: (type: PaywallType, descriptionVariable?: number) =>
          set({ isOpen: true, type, descriptionVariable }),
        closePaywall,
        handleUpgrade: openCheckout,
        handleStartTrial: openCheckout,
        handleClickLink: () => {
          closePaywall()
          pushWithLanguageRoutes('/login')
        },
        reset: closePaywall,
      }
    },
    {
      name: 'paywall-store',
    },
  ),
)
